import {ApprovalStatus} from '@domain/shifthandover'
import {GridSetting} from '@hconnect/uikit'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined'
import {AlertColor} from '@mui/material'
import {ReactNode} from 'react'

export const regularSize: GridSetting = {
  xs: 12,
  sm: 4,
  md: 6
}

const STATUS_ALERT_FONT_SIZE_IN_PX = 16
export const STATUS_ALERT_PROPS: Record<
  ApprovalStatus,
  {getIcon: (fontSize?: number) => ReactNode; severity: AlertColor}
> = {
  pending: {
    getIcon: (fontSize = STATUS_ALERT_FONT_SIZE_IN_PX) => <PendingOutlinedIcon sx={{fontSize}} />,
    severity: 'info'
  },
  approved: {
    getIcon: (fontSize = STATUS_ALERT_FONT_SIZE_IN_PX) => (
      <CheckCircleOutlineOutlinedIcon sx={{fontSize}} />
    ),
    severity: 'success'
  },
  rejected: {
    getIcon: (fontSize = STATUS_ALERT_FONT_SIZE_IN_PX) => <CancelOutlinedIcon sx={{fontSize}} />,
    severity: 'error'
  }
}
